"use client";
import ReviewsModal from "../ReviewsModal/ReviewsModal";
import usePopup from "@/hooks/usePopup";
import { submitproductReviewPopupAtoms } from "@/hooks/headerHooks";
import ReviewForm from "./ReviewForm";
import { useTranslation } from "@/hooks/localization/useTranslations";

const ReviewsFormModal = () => {
  const t = useTranslation();
  const { handleClosePopup, popupValue } = usePopup(
    submitproductReviewPopupAtoms,
  );
  return (
    <ReviewsModal
      title={t.write_your_review}
      popupValue={popupValue!}
      handleClosePopup={handleClosePopup}
      autoHieght
    >
      <ReviewForm />
    </ReviewsModal>
  );
};

export default ReviewsFormModal;
